import { render } from "./quantitativeIntelligenceMonitoring.vue?vue&type=template&id=54b12091&scoped=true"
import script from "./quantitativeIntelligenceMonitoring.vue?vue&type=script&lang=js"
export * from "./quantitativeIntelligenceMonitoring.vue?vue&type=script&lang=js"

import "./quantitativeIntelligenceMonitoring.vue?vue&type=style&index=0&id=54b12091&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54b12091"

export default script